<template>
  <v-container id="vh-acc-list" fluid tag="section">
    <base-material-card outlined icon="mdi-account-outline" class="overflow-visible pb-7">
      <template v-slot:after-heading>
        <div class="font-weight-light card-title mt-2">Tài khoản vui học</div>
      </template>
      <validation-observer v-slot="{ }">
        <v-row>
          <v-col cols="12" md="8">
            <v-tabs color="primary" style="background-color: #FFFFFF; padding: 5px 0px 10px 5px;">
              <v-tab v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.text }}</v-tab>
            </v-tabs>
          </v-col>
        </v-row>
      </validation-observer>
      <v-simple-table class="table-layout pa-5 pb-0">
        <template v-slot:default>
          <thead>
          <tr>
            <th>ID</th>
            <th>Họ và tên</th>
            <th class="fix-width">Tên đăng nhập</th>
            <th class="fix-width">Kết quả học tập</th>
            <th>Thời gian tạo</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="item in listAccount">
            <tr
                :key="item.id"
            >
              <td>{{ _.get(item, 'id', '') }}</td>
              <td class="fix-width">{{ _.get(item, 'full_name', '') }}</td>
              <td>{{ _.get(item, 'user_name', '') }}</td>
              <td>{{ _.get(item, 'study_result', '') }}</td>
              <td>{{ _.get(item, 'create_date', '') }}</td>
            </tr>
          </template>
          </tbody>
          <common-no-result
              v-if="!listAccount.length"
          />
        </template>
      </v-simple-table>
<!--      <common-no-result v-if="totalItem === 0" />-->
      <v-row>
        <v-col cols="12" sm="6" />
        <v-col cols="12" sm="6">
          <v-pagination
              v-if="totalItem > limit"
              v-model="currentPage"
              :length="getTotalItem(totalItem)"
              class="justify-sm-end"
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { contactDetailTabMenu } from '../../helpers/constants';
import RepositoryFactory from '../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');
const UserRepository = RepositoryFactory.get('user');
export default {
  components: {
    
  },
  
  props: {
    
  },
  data() {
    return {
      tabs: [],
      mobile: '',
      currentPage: 1,
      limit: 10,
      listAccount: [],
      totalItem: 0
    }
  },
  async created() {
    await this.getContactDetail();
    this.getListAccVh();
    this.tabs = contactDetailTabMenu(this.$route.params.id)
  },
  methods: {
    async getListAccVh() {
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        user_name: this.mobile
      };
      this.loading = true;
      const loader = this.$loading.show();
      const response = await UserRepository.getListAccVuihoc(
          params
      );
      loader.hide();
      this.loading = false;
      if (response.success) {
        this.listAccount = _.get(response, 'data.data', [])
        this.totalItem = _.get(response, 'data.total', 0);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
        this.contactHistorys = [];
        this.totalItem = 0;
      }
    },
    async getContactDetail() {
      const loader = this.$loading.show()
      const response = await ContactRepository.detail(this.$route.params.id)
      loader.hide()
      if (response.success) {
        let indexMainCustomer = _.get(response, 'data.customers', []).findIndex(item => item.isMainCustomer == true);
        if(indexMainCustomer > -1) {
          this.mobile = _.get(response, 'data.customers', [])[indexMainCustomer].mobile;
        }
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(response, 'message', '')
        });
      }
    }
  }
}
</script>

<style scoped>

</style>